<template>
  <el-tabs v-model='classCheckTab' class='class-inf-detail-list' v-if='classInfo.id'>
    <el-tab-pane label='基础信息' name='base'>
      <div class='base-content'>
        <ul class='list'>
          <li>
            <div class='title'>班级名称</div>
            <div class='content'>{{ classInfo.name }}</div>
          </li>
          <li>
            <div class='title'>所属学年</div>
            <div class='content'>{{ classInfo.year }}</div>
          </li>
          <li>
            <div class='title'>学期类型</div>
            <div class='content'>{{ classInfo.term_type_label }}</div>
          </li>
          <li>
            <div class='title'>所属学期</div>
            <div class='content'>{{ classInfo.term_label }}</div>
          </li>
          <li>
            <div class='title'>课程类型</div>
            <div class='content'>{{ classInfo.class_type_label }}</div>
          </li>
          <li>
            <div class='title'>课程介绍</div>
            <div class='content'>{{ classInfo.course_introduction }}</div>
          </li>
          <li>
            <div class='title'>部门项目</div>
            <div class='content'>
              <div class='slot-right' v-if='classInfo.fee_level'>
                <span>{{ classInfo.fee_level.org_full_name }}</span>
                <span>{{ classInfo.fee_level.specialized_subject_full_name }}</span>
              </div>
            </div>
          </li>
          <li>
            <div class='title'>专业级别</div>
            <div class='content'>
              <div v-if='classInfo.fee_level' class='slot-right'>
                <span>{{ classInfo.fee_level.name }}</span>
                <span>{{ classInfo.class_size }}人</span>
                <span>{{ classInfo.fee_level.single_class_duration }}分钟</span>
                <span>{{ classInfo.fee_level.single_class_price }}元</span>
              </div>
            </div>
          </li>
          <li>
            <div class='title'>班级代码</div>
            <div class='content'>{{ classInfo.class_code }}</div>
          </li>
          <li>
            <div class='title'>退费类型</div>
            <div class='content'>{{ classInfo.refund_type_label }}</div>
          </li>
          <li>
            <div class='title'>材料费退费类型</div>
            <div class='content'>{{ classInfo.material_fee_refund_type_label }}</div>
          </li>
          <li>
            <div class='title'>是否邮寄</div>
            <div class='content'>{{ classInfo.is_need_mailing_label }}</div>
          </li>
          <li>
            <div class='title'>是否门禁</div>
            <div class='content'>{{ classInfo.is_need_access_control_label }}</div>
          </li>
          <li>
            <div class='title'>预留人数</div>
            <div class='content'>{{ classInfo.reserved_count }}人</div>
          </li>
          <li>
            <div class='title'>课酬率</div>
            <div class='content'>{{ classInfo.remuneration | filterRe }}</div>
          </li>
          <li>
            <div class='title'>描述</div>
            <div class='content'>{{ classInfo.class_desc || '一' }}</div>
          </li>
        </ul>
        <ul class='list'>
          <li>
            <div class='title'>班级封面</div>
            <div class='content'>
              <template v-if='media.pc_cover'>
                <img :src='`${baseUrl}/${media.pc_cover}`' width='200px' />
              </template>
            </div>
          </li>
          <template v-if='media.publicity_video'>
            <li>
              <div class='title'>宣传视频</div>
              <div class='content'>
                <video
                  :poster='`${baseUrl}/${media.publicity_cover}`'
                  controls='controls'
                  :src='`${baseUrl}/${media.publicity_video}`'
                  width='400px'
                ></video>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </el-tab-pane>
    <el-tab-pane label='课程表' name='schedule'>
      <ul class='list'>
        <li>
          <div class='title'>课表格式</div>
          <div class='content'>{{ classInfo.class_mode_label }}</div>
        </li>
        <li v-if='classInfo.class_mode === 2'>
          <div class='title'>上课周期</div>
          <div class='content'>{{ classInfo.class_periodic | classPeriodic }}</div>
        </li>
        <template v-if='classInfo.class_mode !== 3 && class_detail.class_date'>
          <li>
            <div class='title'>上课日期</div>
            <div class='content'>{{ class_detail.class_date[0] }} — {{[4,5].includes(+defaultFormItemClass.class_phase) ? '' : class_detail.class_date[1] }}</div>
          </li>
          <li>
            <div class='title'>上课时间</div>
            <div class='content'>{{ class_detail.class_time[0] }} — {{ class_detail.class_time[1] }}</div>
          </li>
          <li>
            <div class='title'>教室</div>
            <div class='content'>{{ class_detail.class_room_name }}</div>
          </li>
        </template>
        <li>
          <div class='title'>任课老师</div>
          <div class='content'>
            {{
              classInfo.teacher
                .filter(item => item.teacher_type === 1)
                .map(item => item.real_name)
                .join('，')
            }}
          </div>
        </li>
        <li v-if='classInfo.teacher.filter(item => item.teacher_type === 2).length'>
          <div class='title'>助教老师</div>
          <div class='content'>
            {{
              classInfo.teacher
                .filter(item => item.teacher_type === 2)
                .map(item => item.real_name)
                .join('，')
            }}
          </div>
        </li>
        <li>
          <div class='title'>课程次数</div>
          <div class='content'>{{ classInfo.courses_count }}次</div>
        </li>
        <template v-if='classInfo.class_mode === 3'>
          <li>
            <div class='title'>课表详情</div>
            <div class='content'>
              <el-button type='primary' @click.native='showSc'>查看</el-button>
            </div>
          </li>
        </template>
      </ul>
    </el-tab-pane>
    <el-tab-pane label='班级费用' name='cost'>
      <ul class='list'>
        <li>
          <div class='title'>学费</div>
          <div class='content'>
            {{ classInfo.class_fee }}元 （单次课费 {{ classInfo.fee_level.single_class_price }} × 课程次数
            {{ classInfo.courses_count }}）
          </div>
        </li>
        <li>
          <div class='title'>保险费</div>
          <div class='content'>{{ classInfo.insurance }}元</div>
        </li>
        <li>
          <div class='title'>材料费</div>
          <div class='content'>{{ classInfo.material_fee }}元</div>
        </li>
        <li>
          <div class='title'>伙食费</div>
          <div class='content'>{{ classInfo.food_expenses }}元</div>
        </li>
<!--        <li>
          <div class='title'>陪读费</div>
          <div class='content'>{{ classInfo.accompanying_fee }}元</div>
        </li>
        <li>
          <div class='title'>托管费</div>
          <div class='content'>{{ classInfo.hosting_fee }}元</div>
        </li>-->
        <li v-if='classInfo.refund_type === 2'>
          <div class='title'>食宿交通门票等</div>
          <div class='content'>{{ classInfo.accommodation_traffic_ticket }}元</div>
        </li>
        <li>
          <div class='title'>明细对外</div>
          <div class='content'>{{ classInfo.show_price_detail_label }}</div>
        </li>
        <li>
          <div class='title'>
            <h3>总费用</h3>
          </div>
          <div class='content'>
            <h3>{{ classInfo.total_fee }}元</h3>
          </div>
        </li>
      </ul>
    </el-tab-pane>
    <el-tab-pane label='限制条件' name='rules'>
      <ul class='list'>
        <li>
          <div class='title'>发布到外网</div>
          <div class='content'>
            <span v-if='classInfo.is_publish'>
              {{ classInfo.sign_up_start_time }} — {{ classInfo.sign_up_end_time }}
            </span>
            <span v-else>否</span>
          </div>
        </li>
        <li v-if='classInfo.is_rocking_number'>
          <div class='title'>摇号</div>
          <div class='content'>
            {{ classInfo.rocking_number_start_time }}
          </div>
        </li>
        <li v-if='classInfo.is_interview'>
          <div class='title'>面试</div>
          <div class='content'>
            {{ classInfo.interview_remarks }}
            <br />
            <p>
              <strong v-if='classInfo.is_limit_reserves_number' class='m-r-20'>有预约人数限制</strong>
            </p>
          </div>
        </li>
        <li v-if='classInfo.is_rocking_number && !classInfo.is_interview'>
          <div class='title'>递补结束时间</div>
          <div class='content'>
            {{ classInfo.auto_fill_end_time }}
          </div>
        </li>
        <li v-if='classInfo.is_rocking_number && !classInfo.is_interview'>
          <div class='title'>补充报名时间</div>
          <div class='content'>
            {{ classInfo.replenish_sign_up_start_time }} —
            {{ classInfo.replenish_sign_up_end_time }}
          </div>
        </li>
        <li v-if='classInfo.is_age_limit'>
          <div class='title'>年龄限制</div>
          <div class='content'>
            <span>{{ classInfo.min_age }}岁 — {{ classInfo.max_age }}岁</span>
            <span style='color: #999'>（ {{ classInfo.min_birthday }} - {{ classInfo.max_birthday }}）</span>
          </div>
        </li>
      </ul>
    </el-tab-pane>
    <el-tab-pane v-if='classInfo.is_limit_reserves_number' label='子班级' name='childClass' class='m-b-20'>
      <child-class ref='childClassComp' :classId='classInfo.id' onlyShow></child-class>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { Tabs, TabPane } from 'element-ui';
import { classApi } from '@/api';
import utils from '@/utils';
import ChildClass from '@/components/ChildClass';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'ClassInfDetailList',
  components: { ElTabs: Tabs, ElTabPane: TabPane, ChildClass },
  props: {
    defaultFormItemClass: {
      required: true,
      type: Object
    },
    isFetch: {
      type: Boolean,
      default: () => false
    },
    class_phase: {
      type: String
    }
  },
  filters: {
    filterRe(value) {
      if (typeof value !== 'number') return '无';
      return `${Decimal.mul(value, 100).toNumber()} %`;
    },
    classPeriodic(value) {
      const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      if (value) {
        return value
          .split(',')
          .map(key => week[key])
          .join('、');
      }
      return '无';
    }
  },
  watch: {
    defaultFormItemClass() {
      if (this.defaultFormItemClass.id) this.init();
    }
  },
  data() {
    return {
      classCheckTab: 'base',
      baseUrl: '',
      media: '',
      class_detail: {
        class_time: [],
        class_date: []
      },
      classInfo: {},
      ageLimitBirthday: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      if (this.isFetch) {
        const res = await classApi.controlClass({
          id: this.defaultFormItemClass.id
        });
        if (res && res.data) {
          this.classInfo = res.data.class_info;
        }
      } else {
        this.classInfo = this.defaultFormItemClass;
      }
      if (!this.classInfo.teacher) {
        this.classInfo.teacher = [];
      }
      const { class_type, material_fee_refund_type } = this.classInfo;
      if (!class_type) {
        this.classInfo.class_type_label = '线下班';
      }
      if (!material_fee_refund_type) {
        this.classInfo.material_fee_refund_type_label = '材料包';
      }
      this.classCheckTab = 'base';
      // 获取多媒体信息地址
      this.baseUrl = await this.$store.dispatch('app/getOssUrl');
      classApi
        .getClassMedia({
          id: this.defaultFormItemClass.id
        })
        .then(resM => {
          if (resM && resM.data) {
            this.media = resM.data.class_cover;
          }
        });
      if (this.defaultFormItemClass.class_mode === 3) return;
      // 获取课表
      if (!this.defaultFormItemClass.id || this.defaultFormItemClass.id < 0) return;
      classApi
        .getClassSchedule({
          id: this.defaultFormItemClass.id
        })
        .then(res => {
          if (res && res.data) {
            this.class_detail = utils.setClassDetail({
              class_mode: this.classInfo.class_mode,
              class_detail: res.data.list
            });
          }
        });
    },
    showSc() {
      this.$emit('showSc', this.defaultFormItemClass);
    }
  }
};
</script>
<style lang='less'>
.class-inf-detail-list {
  .base-content {
    display: flex;
  }

  .list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      overflow: hidden;
      margin-bottom: 10px;
      display: flex;
    }

    .title {
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #606266;
      line-height: 30px;
      padding: 0 10px 0 0;
      box-sizing: border-box;
      width: 120px;
      font-weight: 600;
    }

    .content {
      float: left;
      vertical-align: middle;
      line-height: 30px;
      max-width: 500px;
      // margin-left: 10px;
      p {
        line-height: 2;
      }

      .slot-right {
        display: inline-block;

        span {
          display: inline-block;
          border: 1px solid @main-blue;
          padding: 0 10px;
          margin-right: 15px;
        }
      }
    }
  }
}
</style>
